<template>
  <div>
    <dashboard-core-app-bar>
      <template v-slot:extraContent>
        <v-dialog
          v-model="showEditLocation"
          max-width="650px"
          v-if="$store.getters.canCreateLocation"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon @click="showEditLocation" v-on="on">
              <v-icon>mdi-qrcode-plus</v-icon>
            </v-btn>
          </template>
          <EditLocation :logo="logo" @closeEditLocation="closeEditLocation" />
        </v-dialog>
        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-qrcode-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Upgrade your plan") }}</span>
        </v-tooltip>
        <v-dialog
          v-model="printDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <v-btn icon @click="printDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ $t("Print") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon @click="print()" color="primary">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <PrintLocations />
          </v-card>
        </v-dialog>
        <v-spacer />
      </template>
    </dashboard-core-app-bar>
    <BodyContainer class="d-flex align-content-space-around flex-wrap" v-if="!printDialog">
      <BodyCard :outlined="false">
        <div class="d-flex align-content-space-around flex-wrap" flat>
          <LocationCard
            v-for="(location, index) in locations"
            :key="index + 'location'"
            :location="location"
            :logo="logo"
            :index="index"
          />
        </div>
      </BodyCard>
    </BodyContainer>
  </div>
</template>

<script>
import LocationCard from "@/views/dashboard/components/locations/LocationCard";
import EditLocation from "@/views/dashboard/components/locations/EditLocation";
import PrintLocations from "@/views/dashboard/components/locations/PrintLocations";
import BodyCard from "@/views/dashboard/components/BodyCard";

import Location from "@/model/location.js";

export default {
  components: {
    DashboardCoreAppBar: () =>
      import("@/views/dashboard/components/core/AppBar"),
    BodyContainer: () => import("@/views/dashboard/components/BodyContainer"),
    LocationCard,
    EditLocation,
    PrintLocations,
    BodyCard
    // Printer
  },
  data() {
    return {
      printDialog: false,
      toPrint: false,
      newLocationDialog: false,
      logo: this.$store.getters.restaurant.logo,
      notify: false,
      showEditLocation: false
    };
  },
  methods: {
    openEditLocation() {
      this.showEditLocation = true;
    },
    closeEditLocation() {
      this.showEditLocation = false;
    },
    print() {
      window.print();
    }
  },
  computed: {
    emptyLocation() {
      return new Location();
    },
    locations() {
      return this.$store.getters.locations;
    }
  }

  //
};
</script>
<style></style>
